import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/builtin/asyncToGenerator";
import fetch from "node-fetch";
var SERVER_URL = "https://github-trending-api.now.sh";

function buildUrl(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = Object.keys(t).map(function (e) {
    return "".concat(encodeURIComponent(e), "=").concat(encodeURIComponent(t[e]));
  }).join("&");
  return "" === r ? e : "".concat(e, "?").concat(r);
}

function fetchAllLanguages() {
  return _fetchAllLanguages.apply(this, arguments);
}

function _fetchAllLanguages() {
  return (_fetchAllLanguages = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
    var t;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.next = 2, fetch("".concat(SERVER_URL, "/languages"));

          case 2:
            return t = e.sent, e.abrupt("return", t.json());

          case 4:
          case "end":
            return e.stop();
        }
      }
    }, e, this);
  }))).apply(this, arguments);
}

function fetchRepositories(e) {
  return _fetchRepositories.apply(this, arguments);
}

function _fetchRepositories() {
  return (_fetchRepositories = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
    var r;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.next = 2, fetch(buildUrl("".concat(SERVER_URL, "/repositories"), t));

          case 2:
            return r = e.sent, e.abrupt("return", r.json());

          case 4:
          case "end":
            return e.stop();
        }
      }
    }, e, this);
  }))).apply(this, arguments);
}

function fetchDevelopers(e) {
  return _fetchDevelopers.apply(this, arguments);
}

function _fetchDevelopers() {
  return (_fetchDevelopers = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
    var r;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.next = 2, fetch(buildUrl("".concat(SERVER_URL, "/developers"), t));

          case 2:
            return r = e.sent, e.abrupt("return", r.json());

          case 4:
          case "end":
            return e.stop();
        }
      }
    }, e, this);
  }))).apply(this, arguments);
}

export { fetchAllLanguages, fetchRepositories, fetchDevelopers };